module.exports = __webpack_public_path__ + "static/media/css.a86dce4f.jpeg";